const popups = {
  'popups-breadcrumbs': 'Диалоги',
  'popups-details-title': 'Диалог',
  'popups-filter-title': 'Фильтр диалогов',
  'popups-priority-title': 'Установите правильный порядок диалогов',
  'popups-priority-filter-title': 'Выберите диалоги по дате',
  'popups-priority-updated-successfully': 'Приоритет диалогов обновлен',
  'popups-priority-updated-failed': 'Ошибка при обновлении приоритета диалогов',
  'popups-unpublish-used-notification': 'Нельзя снять с публикации диалог, привязанный к событию',
};

export default popups;
